import { Form, Formik, FormikProps } from 'formik'
import { OfferRecipientV3 } from '../OfferRecipientV3/OfferRecipientV3'
import { OfferRecipients } from '../../../types/flyout'
import { offerRecipientValidation } from '../../utils/offerRecipientValidation'
import { ButtonV2 } from '@labrav/react-components'
import { useStyles } from './EditRecipients.styles'
import { useSelector } from '../../../store'
import { CloudMarketplace } from '../../../types'
import { LoadingTypes, isLoading as Loading } from '@labrav/common'

export const EditRecipients = ({
  offerRecipients,
  handleCloseRecipients,
  offerId,
  handleSubmit,
  isUpdateLoading,
  cloud,
  updateOfferRecipientsById,
}: {
  offerRecipients: OfferRecipients[]
  handleCloseRecipients: () => void
  offerId?: string
  handleSubmit?: (offerRecipients: OfferRecipients[]) => void
  isUpdateLoading?: boolean
  cloud?: CloudMarketplace
  updateOfferRecipientsById?: (
    offerId: string,
    offerRecipients: OfferRecipients[],
    onSuccess: () => void
  ) => void | Promise<void>
}) => {
  const { classes } = useStyles()
  const isLoading = useSelector<boolean>(state =>
    Loading(state.loading)(LoadingTypes.GENERAL)
  )
  const initialValuesRecipients = {
    offerRecipients: offerRecipients,
  }

  const handleSubmitRecipient = async (values: {
    offerRecipients: OfferRecipients[]
  }) => {
    const offerRecipientsToSend = values?.offerRecipients.map(recipient => {
      const {
        firstName,
        lastName,
        email,
        title,
        crmObjectId,
        firstViewedAt,
        sentAt,
        lastViewedAt,
      } = recipient
      return {
        firstName,
        lastName,
        email,
        title,
        crmObjectId,
        ...(cloud === 'AZURE' ? { firstViewedAt, sentAt, lastViewedAt } : {}),
      }
    })
    if (handleSubmit) {
      handleSubmit(offerRecipientsToSend)
    } else if (offerId && updateOfferRecipientsById) {
      await updateOfferRecipientsById(
        offerId,
        offerRecipientsToSend,
        handleCloseRecipients
      )
    }
  }
  return (
    <Formik
      initialValues={initialValuesRecipients}
      validationSchema={offerRecipientValidation}
      validateOnMount={true}
      onSubmit={async values => {
        await handleSubmitRecipient(values)
      }}
      enableReinitialize
    >
      {formikProps => {
        const handleSubmit = async () => {
          await formikProps?.submitForm()
        }
        return (
          <Form>
            <OfferRecipientV3
              formik={
                formikProps as unknown as FormikProps<Record<string, unknown>>
              }
              borderLess
            />
            <div className={classes.rowRightItem}>
              <ButtonV2
                data-testid="cancel-recipient"
                smallVariant
                styleType="outlined"
                onClick={handleCloseRecipients}
              >
                Cancel
              </ButtonV2>

              <ButtonV2
                data-testid="save-recipient"
                smallVariant
                styleType="primary"
                onClick={handleSubmit}
                loading={isUpdateLoading || isLoading}
              >
                Save
              </ButtonV2>
            </div>
          </Form>
        )
      }}
    </Formik>
  )
}
